/**
 * 修復 URL 中的常見問題
 * @param {string} url - 需要修復的 URL
 * @returns {string} - 修復後的 URL
 */
export function fixUrl(url) {
  if (!url || typeof url !== 'string') return '';
  
  try {
    // 檢查是否已經是完整的 YouTube 縮圖 URL
    if (url.match(/^https?:\/\/(i\.ytimg\.com|img\.youtube\.com)/)) {
      return url;
    }
    
    // 處理雙重 https 問題
    if (url.startsWith('https://https')) {
      url = url.replace('https://https', 'https');
    }
    
    // 處理編碼的 URL
    if (url.includes('%3A')) {
      try {
        url = decodeURIComponent(url);
      } catch (e) {
        console.error('URL 解碼失敗:', e);
      }
    }
    
    // 移除錯誤的前綴
    if (url.includes('backend:8000/media/')) {
      url = url.replace(/https?:\/\/backend:8000\/media\//, '');
    }
    if (url.includes('127.0.0.1:8000/media/')) {
      url = url.replace(/https?:\/\/127\.0\.0\.1:8000\/media\//, '');
    }
    if (url.includes('localhost:8000/media/')) {
      url = url.replace(/https?:\/\/localhost:8000\/media\//, '');
    }
    if (url.includes('localhost:3000/')) {
      url = url.replace(/https?:\/\/localhost:3000\//, '');
    }
    
    // 處理 YouTube 縮圖 URL
    if (url.includes('i.ytimg.com') || url.includes('img.youtube.com')) {
      // 修復 URL 中缺少的斜杠
      if (url.startsWith('https:/') && !url.startsWith('https://')) {
        url = 'https://' + url.substring(7);
      }
      if (url.startsWith('http:/') && !url.startsWith('http://')) {
        url = 'http://' + url.substring(6);
      }
      
      // 確保 URL 有正確的協議
      if (url.startsWith('//')) {
        url = 'https:' + url;
      } else if (!url.startsWith('http')) {
        url = 'https://' + url;
      }
    }
    
    return url;
  } catch (error) {
    console.error('URL 修復失敗:', error);
    return url;
  }
}

/**
 * 獲取 YouTube 視頻縮圖
 * @param {string} url - YouTube 視頻 URL
 * @returns {string} - 縮圖 URL
 */
export function getYoutubeThumbnail(url) {
  url = fixUrl(url);
  
  // 如果已經是縮圖 URL，直接返回
  if (url.includes('i.ytimg.com') || url.includes('img.youtube.com')) {
    return url;
  }
  
  // 提取視頻 ID
  const videoId = url.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^\/&\?]{10,12})/);
  if (videoId) {
    return `https://img.youtube.com/vi/${videoId[1]}/mqdefault.jpg`;
  }
  
  return '';
}

/**
 * 檢查 URL 是否為 YouTube URL
 * @param {string} url - 需要檢查的 URL
 * @returns {boolean} - 是否為 YouTube URL
 */
export function isYoutubeUrl(url) {
  url = fixUrl(url);
  return url.includes('youtube.com') || url.includes('youtu.be');
} 